import LineSeparator from '../../Basic/LineSeparator/LineSeparator.mjs';
import styled from 'styled-components';

styled.div `
  display: block;

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    display: none;
  }
`;
styled.div `
  display: none;

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    display: block;
  }
`;
styled.section `
  margin: 0 auto;
  max-width: ${props => props.theme.breakpoints.xxl};
  box-sizing: border-box;
`;
const StyledLineSeparator = styled(LineSeparator) `
  margin: 0.828125rem 0;
`;

export { StyledLineSeparator };
//# sourceMappingURL=TopVideos.styles.mjs.map
